import './style.scss';
import Text from './text.js';

export default Text;